import { render, staticRenderFns } from "./ImageOff.vue?vue&type=template&id=15a47635"
import script from "./ImageOff.vue?vue&type=script&lang=js"
export * from "./ImageOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports